export default __webpack_public_path__ + "static/media/anjeloClosed.27d7e7cf.jpg";